/**
 * Map a File's MIME type to the backend's required `kind` value.
 * POST /api/media requires `kind` to be one of: image | document | video.
 */
export function kindForFile(file) {
  const type = file?.type || '';
  if (type.startsWith('image/')) return 'image';
  if (type.startsWith('video/')) return 'video';
  return 'document';
}
